
import {Component, Prop, PropSync, Vue} from 'vue-property-decorator';
import {ToolDocument} from "@/models/tobject.model";
import {SCREEN_STORE_ACTIVE} from "@/configs/colors";
import DeleteDialog from "@/components/stead/store/screens/DeleteDialog.vue";
@Component({
  components: {DeleteDialog}
})
export default class AccessoryStoreListCard extends Vue {
  // Les props
  @Prop({default: null}) private tool!: ToolDocument | null
  @Prop({default: false}) private readonly!: boolean
  @PropSync('curtool', {default: null}) private curToolDoc!: ToolDocument | null

  // Les propriétés

  // Les propriétés calculées
  private get showDelete() {
    return this.tool && this.curToolDoc && this.tool._id === this.curToolDoc._id && !this.readonly
  }
  private get canModify(): boolean {
    return !this.$store.getters['current/userIsViewer']
  }
  // Les hooks
  // Les méthodes surveillées
  // Les méthodes d'instance
  private onClickedCard() {
    this.curToolDoc = this.tool
  }

  private cardStyle(hover: boolean) {
    return this.curToolDoc && this.tool && this.curToolDoc._id === this.tool._id
        ? `background-color: ${SCREEN_STORE_ACTIVE}`
        : hover ? 'background-color: rgba(0, 0, 0, .04)' : undefined
  }

  // Les méthodes statiques
}
